export enum ConvertableIdFormat {
    EwsId = 'ews',
    EwsImmutableId = 'ewsimmutable',
}
